import { useNavigate } from 'react-router-dom';

interface Props {
  showBack?: boolean;
  backRoute?: string;
  onBack?: () => void;
  customTitle?: string;
}

export function GlobalHeader({ showBack, backRoute, onBack, customTitle }: Props) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) { onBack(); return; }
    if (backRoute) { navigate(backRoute); return; }
    navigate(-1);
  };

  return (
    <div className="global-header">
      <div className="global-header__bar">
        {showBack ? (
          <button type="button" onClick={handleBack} className="global-header__back">
            ←
          </button>
        ) : (
          <div style={{ width: '60px' }} />
        )}

        <span className="global-header__title">
          {customTitle ?? 'VADOStudy'}
        </span>

        <div style={{ width: '60px' }} />
      </div>
    </div>
  );
}
